module.exports = __webpack_public_path__ + "fonts/iconfont.bd1b43b.ttf";